import React, { useEffect, useState } from "react";

import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isItem, setIsItem] = useState(false);
  const [isMenuSetup, setIsMenuSetup] = useState(false);
  const [isIntell, setIsIntell] = useState(false);
  const [isBlog, setIsBlog] = useState(false);
  const [isMedia, setIsMedia] = useState(false);
  const [isTeam, setIsTeam] = useState(false);
  const [isCourse, setIsCourse] = useState(false);

  const [isPrivacy, setIsPrivacy] = useState(false);
  const [isTestimonial, setIsTestimonial] = useState(false);

  const [isBranch, setIsBranch] = useState(false);
  const [isDestination, setIsDestination] = useState(false);

  const [isTermCondition, setIsTermCondition] = useState(false);
  const [isAffiliated, setIsAffiliated] = useState(false);
  const [isStudentForms, setIsStudentForms] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isWaiter, setIsWaiter] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const [isFAQ, setIsFAQ] = useState(false);
  const [isPrivacySettings, setIsPrivacySettings] = useState(false);
  const [isConfig, setIsConfig] = useState(false);

  const [isWhoweare, setIsWhoWeAre] = useState(false);
  const [isMessage, setIsMessage] = useState(false);

  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.roles[0]?.toLowerCase();
  // console.log("🚀 ~ Navdata ~ userRole:", userRole);
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  // const isSuperAdmin = true;
  // console.log("isSuperAdmin", isSuperAdmin);
  // const isAdmin = true;

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "team-mgmt") {
      setIsTeam(false);
    }
    if (iscurrentState !== "faq") {
      setIsFAQ(false);
    }
    if (iscurrentState !== "testimonial") {
      setIsTestimonial(false);
    }
    if (iscurrentState !== "legal-policy") {
      setIsPrivacy(false);
    }

    if (iscurrentState !== "termscondition") {
      setIsTermCondition(false);
    }
    if (iscurrentState !== "affiliated") {
      setIsAffiliated(false);
    }
    if (iscurrentState !== "student-forms") {
      setIsStudentForms(false);
    }

    if (iscurrentState !== "pages") {
      setIsSetting(false);
    }

    if (iscurrentState !== "settings") {
      setIsWaiter(false);
    }
    if (iscurrentState !== "Table") {
      setIsTable(false);
    }
    if (iscurrentState !== "location") {
      setIsBranch(false);
    }
    if (iscurrentState !== "destination-countries") {
      setIsDestination(false);
    }
    if (iscurrentState !== "content-mgmt") {
      setIsUser(false);
    }
    if (iscurrentState !== "database-management") {
      setIsItem(false);
    }

    if (iscurrentState !== "blog") {
      setIsBlog(false);
    }
    if (iscurrentState !== "courses") {
      setIsCourse(false);
    }
    if (iscurrentState !== "menu-setup") {
      setIsMenuSetup(false);
    }
    if (iscurrentState !== "media-mgmt") {
      setIsMedia(false);
    }
    if (iscurrentState !== "privacy-settings") {
      setIsPrivacySettings(false);
    }
    if (iscurrentState !== "messagefromceo") {
      setIsMessage(false);
    }
    if (iscurrentState !== "whoweare") {
      setIsWhoWeAre(false);
    }
    if (iscurrentState !== "email-configuration") {
      setIsConfig(false);
    }
    if (iscurrentState !== "intelligence") {
      setIsIntell(false);
    }
  }, [
    history,
    isIntell,
    iscurrentState,
    isDashboard,
    isTestimonial,
    isItem,
    isTeam,
    isFAQ,
    isTestimonial,
    isPrivacy,

    isTermCondition,
    isAffiliated,
    isStudentForms,
    isUser,
    isSetting,
    isWaiter,
    isTable,
    isBranch,
    isDestination,
    isBlog,
    isMenuSetup,
    isMedia,
    isConfig,
  ]);

  const superAdminMenu = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    // {
    //   id: "intelligence",
    //   label: "KFA Intelligence",
    //   icon: "bx bxs-report",
    //   link: "/intelligence",
    //   parentId: "intelligence",
    //   click: (e) => {
    //     e.preventDefault();
    //     setIsIntell(!isIntell);
    //     setIscurrentState("intelligence");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isIntell,
    //   subItems: [
        
        
    //     {
    //       id: "product-services",
    //       label: "Product & Services",
    //       link: "/product-services",
    //       parentId: "intelligence",
    //     },
    //     {
    //       id: "channel-partners",
    //       label: "Channel Partners",
    //       link: "/channel-partners",
    //       parentId: "intelligence",
    //     },
       
    //     {
    //       id: "widgets",
    //       label: "Widgets",
    //       link: "/widgets",
    //       parentId: "intelligence",
    //     },
    //     {
    //       id: "institute-widget",
    //       label: "Institute Widget",
    //       link: "/institute-widget",
    //       parentId: "intelligence",
    //     },
    //      {
    //       id: "destination-widget",
    //       label: "Destination Widget",
    //       link: "/destination-widget",
    //       parentId: "intelligence",
    //     },
    //   ],
    // },
    {
      id: "menu-setup",
      label: "Menu Setup",
      icon: "bx bxs-report",
      link: "/menu-setup",
      parentId: "menu-setup",
      click: (e) => {
        e.preventDefault();
        setIsMenuSetup(!isMenuSetup);
        setIscurrentState("menu-setup");
        updateIconSidebar(e);
      },
      stateVariables: isMenuSetup,
      subItems: [
        // {
        //   id: "menu-type",
        //   label: "Menu type",
        //   link: "/menu-type",
        //   parentId: "menu-setup",
        // },
        {
          id: "menu",
          label: "Menu",
          link: "/menu",
          parentId: "menu-setup",
        },
      ],
    },
    {
      id: "media-mgmt",
      label: "Media Management",
      icon: "bx bxs-report",
      link: "/media-mgmt",
      parentId: "media-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsMedia(!isMedia);
        setIscurrentState("media-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isMedia,
      subItems: [
        {
          id: "mediagroup",
          label: "Media Group",
          link: "/media-group",
          parentId: "media-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "media",
          label: "Media",
          link: "/media-list",
          parentId: "media-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
      ],
    },
    {
      id: "content-mgmt",
      label: "Content Management",
      icon: "bx bxs-report",
      link: "/content-mgmt",
      parentId: "content-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("content-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isUser,
      subItems: [
        {
          id: "banner",
          label: "Banner Sections",
          link: "/banner-section",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "home",
          label: "Home Sections",
          link: "/homesection",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "pages",
          label: "Pages",
          link: "/pages-list",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsSetting(!isSetting);
          //   setIscurrentState("pages");
          //   updateIconSidebar(e);
          // },
        },

        {
          id: "whoweare",
          label: "Who We Are",
          // icon: "ri-settings-3-line",
          link: "/who-we-are",
          parentId: "content-mgmt",
        },
        {
          id: "messagefromceo",
          label: "Message From CEO",
          // icon: "ri-settings-3-line",
          link: "/message-from-ceo",
          parentId: "content-mgmt",
        },
        {
          id: "timeline",
          label: "Timelines",
          link: "/timeline",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsSetting(!isSetting);
          //   setIscurrentState("pages");
          //   updateIconSidebar(e);
          // },
        },

        // {
        //   id: "videos",
        //   label: "Videos",
        //   link: "/video-list",
        //   parentId: "content-mgmt",

        // },
        {
          id: "blog-list",
          label: "Blogs",
          // icon: "ri-settings-3-line",
          link: "/blog",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsBlog(!isBlog);
          //   setIscurrentState("blog");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "course-list",
          label: "Courses",
          link: "/courses",
          parentId: "content-mgmt",
        },
        {
          id: "new-list",
          label: "News",
          link: "/news",
          parentId: "content-mgmt",
        },
        {
          id: "event-list",
          label: "Events",
          link: "/event",
          parentId: "content-mgmt",
        },

        {
          id: "tag-list",
          label: "Tags",
          link: "/tag",
          parentId: "content-mgmt",
        },
        {
          id: "destination-country",
          label: "Destination Countries",
          link: "/destination-countries",
          parentId: "content-mgmt",
        },
        {
          id: "test-preparations",
          label: "Test Preparation",
          link: "/test-preparation",
          parentId: "content-mgmt",
        },
      ],
    },
    {
      id: "team-mgmt",
      label: "User Management",
      icon: "bx bxs-report",
      link: "/team-mgmt",
      parentId: "team-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsTeam(!isTeam);
        setIscurrentState("team-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isTeam,
      subItems: [
        {
          id: "roles",
          label: "Partners",
          link: "/partners",
          parentId: "team-mgmt",
        },
        {
          id: "users",
          label: "Users",

          link: "/user",
          parentId: "team-mgmt",
        },
        {
          id: "student-form",
          label: "Student Forms",
          // icon: "ri-settings-3-line",
          link: "/student-forms",
          parentId: "team-mgmt",
        },
        {
          id: "event-form",
          label: "Event Forms",
          // icon: "ri-settings-3-line",
          link: "/event-forms",
          parentId: "team-mgmt",
        },
        {
          id: "joblistings",
          label: "Job Listing",
          link: "/joblisting",
          parentId: "team-mgmt",
        },
        {
          id: "job-applications",
          label: "Job Application",

          link: "/job-application",
          parentId: "team-mgmt",
        },

        {
          id: "partners",
          label: "Roles",
          link: "/roles",
          parentId: "team-mgmt",
        },
        {
          id: "franchise-enquirys",
          label: "Franchise Enquiry",
          link: "/franchise-enquiry",
          parentId: "team-mgmt",
        },
         {
          id: "franchise-private",
          label: "Franchise Private",
          link: "/franchise-private",
          parentId: "team-mgmt",
        },
      ],
    },

    {
      id: "location",
      label: "Location & Affiliation",
      icon: "bx bxs-report",
      link: "/location",
      parentId: "location",
      click: (e) => {
        e.preventDefault();
        setIsBranch(!isBranch);
        setIscurrentState("location");
        updateIconSidebar(e);
      },
      stateVariables: isBranch,
      subItems: [
        {
          id: "branch-location",
          label: "Branch Location",
          // icon: "ri-settings-3-line",
          link: "/branch",
          parentId: "location",
        },

        {
          id: "affiliated",
          label: "Affiliated Institute",
          // icon: "ri-settings-3-line",
          link: "/institute",
          parentId: "location",
        },
        {
          id: "faqs",
          label: "FAQ",
          // icon: "ri-settings-3-line",
          link: "/faq",
          parentId: "location",
        },
        {
          id: "faq-groups",
          label: "FAQ Group",
          // icon: "ri-settings-3-line",
          link: "/faq-group",
          parentId: "location",
        },
        {
          id: "testimonials",
          label: "Testimonials",
          // icon: "ri-settings-3-line",
          link: "/testimonial",
          parentId: "location",
        },
        {
          id: "news-letters",
          label: "Newsletter",
          link: "/news-letter",
          parentId: "location",
        },
      ],
    },
    {
      id: "email-configuration",
      label: "Email Configuration",
      icon: "bx bx-envelope",
      link: "/email-configuration",
      parentId: "email-configuration",
      click: (e) => {
        e.preventDefault();
        setIsConfig(!isConfig);
        setIscurrentState("email-configuration");
        updateIconSidebar(e);
      },
      stateVariables: isConfig,
      subItems: [
        {
          id: "email-recipients",
          label: "Email Recipient",
          link: "/email-recipient",
          parentId: "privacy-settings",
        },
        {
          id: "email-configs",
          label: "Email Configuration",
          link: "/email-config",
          parentId: "privacy-settings",
        },
      ],
    },
    {
      id: "privacy-settings",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/privacy-settings",
      parentId: "privacy-settings",
      click: (e) => {
        e.preventDefault();
        setIsPrivacySettings(!isPrivacySettings);
        setIscurrentState("privacy-settings");
        updateIconSidebar(e);
      },
      stateVariables: isPrivacySettings,
      subItems: [
        {
          id: "privacy-policys",
          label: "Privacy Policy",
          link: "/system-setup",
          parentId: "privacy-settings",
        },
        {
          id: "terms-and-conditions",
          label: "Terms and Conditions",
          link: "/terms-condition",
          parentId: "privacy-settings",
        },
        {
          id: "footer-infos",
          label: "Footer Info Section",
          link: "/footer-info",
          parentId: "privacy-settings",
        },

        {
          id: "clear-data",
          label: "Clear Student Form",
          link: "/clear-student-data",
          parentId: "privacy-settings",
        },
      ],
    },
  ];
  const adminMenu = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "menu-setup",
      label: "Menu Setup",
      icon: "bx bxs-report",
      link: "/menu-setup",
      parentId: "menu-setup",
      click: (e) => {
        e.preventDefault();
        setIsMenuSetup(!isMenuSetup);
        setIscurrentState("menu-setup");
        updateIconSidebar(e);
      },
      stateVariables: isMenuSetup,
      subItems: [
        // {
        //   id: "menu-type",
        //   label: "Menu type",
        //   link: "/menu-type",
        //   parentId: "menu-setup",
        // },
        {
          id: "menus",
          label: "Menu",
          link: "/menu",
          parentId: "menu-setup",
        },
      ],
    },
    {
      id: "media-mgmt",
      label: "Media Management",
      icon: "bx bxs-report",
      link: "/media-mgmt",
      parentId: "media-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsMedia(!isMedia);
        setIscurrentState("media-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isMedia,
      subItems: [
        {
          id: "media-groups",
          label: "Media Group",
          link: "/media-group",
          parentId: "media-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "media",
          label: "Media",
          link: "/media-list",
          parentId: "media-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
      ],
    },
    {
      id: "content-mgmt",
      label: "Content Management",
      icon: "bx bxs-report",
      link: "/content-mgmt",
      parentId: "content-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("content-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isUser,
      subItems: [
        {
          id: "banner",
          label: "Banner Sections",
          link: "/banner-section",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "home",
          label: "Home Sections",
          link: "/homesection",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsUser(!isUser);
          //   setIscurrentState("media");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "pages",
          label: "Pages",
          link: "/pages-list",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsSetting(!isSetting);
          //   setIscurrentState("pages");
          //   updateIconSidebar(e);
          // },
        },

        {
          id: "timeline",
          label: "Timelines",
          link: "/timeline",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsSetting(!isSetting);
          //   setIscurrentState("pages");
          //   updateIconSidebar(e);
          // },
        },

        // {
        //   id: "videos",
        //   label: "Videos",
        //   link: "/video-list",
        //   parentId: "content-mgmt",

        // },

        {
          id: "blogs",
          label: "Blogs",
          // icon: "ri-settings-3-line",
          link: "/blog",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsBlog(!isBlog);
          //   setIscurrentState("blog");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "course",
          label: "Courses",
          // icon: "bx bx-group",
          link: "/courses",
          parentId: "content-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsCourse(!isCourse);
          //   setIscurrentState("courses");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "new",
          label: "News",
          link: "/news",
          parentId: "content-mgmt",
        },
        {
          id: "events",
          label: "Events",
          link: "/event",
          parentId: "content-mgmt",
        },
        // {
        //   id: "roles",
        //   label: "Roles",
        //   link: "/roles",
        //   parentId: "content-mgmt",
        // },
        {
          id: "tags",
          label: "Tags",
          link: "/tag",
          parentId: "content-mgmt",
        },
        {
          id: "destination-country",
          label: "Destination Countries",
          link: "/destination-countries",
          parentId: "content-mgmt",
        },
        {
          id: "test-preparations",
          label: "Test Preparation",
          link: "/test-preparation",
          parentId: "content-mgmt",
        },
      ],
    },
    {
      id: "team-mgmt",
      label: "User Management",
      icon: "bx bxs-report",
      link: "/team-mgmt",
      parentId: "team-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsTeam(!isTeam);
        setIscurrentState("team-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isTeam,
      subItems: [
        {
          id: "roles",
          label: "Partners",
          link: "/partners",
          parentId: "team-mgmt",
        },
        {
          id: "users",
          label: "Users",

          link: "/user",
          parentId: "team-mgmt",
        },
        {
          id: "student-form",
          label: "Student Forms",
          // icon: "ri-settings-3-line",
          link: "/student-forms",
          parentId: "team-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsStudentForms(!isStudentForms);
          //   setIscurrentState("student-forms");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "event-form",
          label: "Event Forms",
          // icon: "ri-settings-3-line",
          link: "/event-forms",
          parentId: "team-mgmt",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsStudentForms(!isStudentForms);
          //   setIscurrentState("student-forms");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "joblistings",
          label: "Job Listing",
          link: "/joblisting",
          parentId: "team-mgmt",
        },
        {
          id: "job-applications",
          label: "Job Application",

          link: "/job-application",
          parentId: "team-mgmt",
        },

        {
          id: "partners",
          label: "Roles",
          link: "/roles",
          parentId: "team-mgmt",
        },
        {
          id: "franchise-enquirys",
          label: "Franchise Enquiry",
          link: "/franchise-enquiry",
          parentId: "team-mgmt",
        },
         {
          id: "franchise-private",
          label: "Franchise Private",
          link: "/franchise-private",
          parentId: "team-mgmt",
        },
      ],
    },

    {
      id: "location",
      label: "Location & Affiliation",
      icon: "bx bxs-report",
      link: "/location",
      parentId: "location",
      click: (e) => {
        e.preventDefault();
        setIsBranch(!isBranch);
        setIscurrentState("location");
        updateIconSidebar(e);
      },
      stateVariables: isBranch,
      subItems: [
        {
          id: "branch-locations",
          label: "Branch Location",
          // icon: "ri-settings-3-line",
          link: "/branch",
          parentId: "location",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsBranch(!isBranch);
          //   setIscurrentState("branch-location");
          //   updateIconSidebar(e);
          // },
        },

        {
          id: "affiliated",
          label: "Affiliated Institute",
          // icon: "ri-settings-3-line",
          link: "/institute",
          parentId: "location",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsPrivacy(!isPrivacy);
          //   setIscurrentState("affiliated");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "faqs",
          label: "FAQ",
          // icon: "ri-settings-3-line",
          link: "/faq",
          parentId: "location",
        },
        {
          id: "faq-groups",
          label: "FAQ Group",
          // icon: "ri-settings-3-line",
          link: "/faq-group",
          parentId: "location",
        },
        {
          id: "testimonials",
          label: "Testimonials",
          // icon: "ri-settings-3-line",
          link: "/testimonial",
          parentId: "location",
          // click: (e) => {
          //   e.preventDefault();
          //   setIsTestimonial(!isTestimonial);
          //   setIscurrentState("testimonial");
          //   updateIconSidebar(e);
          // },
        },
        {
          id: "news-letters",
          label: "Newsletter",
          link: "/news-letter",
          parentId: "location",
        },
      ],
    },
    {
      id: "privacy-settings",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/privacy-settings",
      parentId: "privacy-settings",
      click: (e) => {
        e.preventDefault();
        setIsPrivacySettings(!isPrivacySettings);
        setIscurrentState("privacy-settings");
        updateIconSidebar(e);
      },
      stateVariables: isPrivacySettings,
      subItems: [
        {
          id: "privacy-policys",
          label: "Privacy Policy",
          link: "/system-setup",
          parentId: "privacy-settings",
        },
        {
          id: "terms-and-conditions",
          label: "Terms and Conditions",
          link: "/terms-condition",
          parentId: "privacy-settings",
        },
        {
          id: "footer-infos",
          label: "Footer Info Section",
          link: "/footer-info",
          parentId: "privacy-settings",
        },
      ],
    },
  ];
  return (
    <React.Fragment>{isSuperAdmin ? superAdminMenu : adminMenu}</React.Fragment>
  );
};

export default Navdata;
